import React from 'react';
import {Box, Center, Flex, Link, Text} from '@chakra-ui/react';

import { CallToAction } from '../../Components';

export const Membership = () => {
  const additional = {
    applications: {
      new_members: "https://waiver.smartwaiver.com/w/4xezlyxj2lgpjfyghb7qew/web/",
      renewal: "https://waiver.smartwaiver.com/w/iegblikbmcdvdnpgorzmjs/web/",
      title: "Membership Applications"
    },
    types: {
      title: "Membership Types",
      subtitle: "Golden Gun Club offers Three (3) Membership Levels to its Members",
      ctas: [
        {
          title: "Full Membership",
          image: "https://ggc-website-public-content.s3.amazonaws.com/images/inset-a.jpg",
          main: "A full Member is entitled to participate in all Membership activities, including voting at the Club's annual meeting, access to the rifle and pistol range, discounts for clay targets on the Shotgun Range, and the ability to bring up to 2 guests. The spouse and or family of a Full Member living in the same household may also apply for a Spouse/Family Membership at a discounted rate."
        },
        {
          title: "Shotgun-Only Membership",
          image: "https://ggc-website-public-content.s3.amazonaws.com/images/inset-b.jpg",
          main: "Entitles the Member discounted targets on the shotgun facility, but no access to the rifle and pistol ranges. A Shotgun Only Member is not entitled to vote in Club elections or meetings, though welcome to attend."
        },
        {
          title: "Spouse/Family Membership",
          image: "https://ggc-website-public-content.s3.amazonaws.com/images/inset-c.jpg",
          main: "The spouse or adult children of a Full Member may apply for a Spouse/Family Membership at a discounted rate. Spouse/Family Members may vote in Club elections or meetings."
        }
      ]
    },
    amenities: {
      title: "Membership Has Its Privileges!",
      subtitle: "All Members of the Club can enjoy the following amenities provided by the Club to its Membership:",
      ctas: [
        {
          title: "Full Range Access",
          image: "https://ggc-website-public-content.s3.amazonaws.com/images/inset-a.jpg",
          main: "Sunrise-to-Sunset, 365 days a year access to the rifle/pistol ranges, subject to range closures for weather or maintenance"
        },
        {
          title: "Discounted Shotgun Targets",
          image: "https://ggc-website-public-content.s3.amazonaws.com/images/inset-a.jpg",
          main: "For sale in the clubhouse during business hours (see footer for hours), subject to availability"
        },
        {
          title: "Access to the Clubhouse",
          image: "https://ggc-website-public-content.s3.amazonaws.com/images/inset-a.jpg",
          main: "Open during business hours (see footer for current hours)"
        },
        {
          title: "Discount on Match Program Fees",
          image: "https://ggc-website-public-content.s3.amazonaws.com/images/inset-a.jpg",
          main: "Enjoy match entry discounts for most match programs hosted by Golden Gun Club"
        },
        {
          title: "CMP Club Privileges",
          image: "https://ggc-website-public-content.s3.amazonaws.com/images/inset-a.jpg",
          main: "As a CMP registered club, Members can purchase firearms, ammunition and accessories through the CMP website"
        },
        {
          title: "Visitors for Members",
          image: "https://ggc-website-public-content.s3.amazonaws.com/images/inset-a.jpg",
          main: "Members can host up to two (2) Visitors at the Club for a given range session, subject to Visitor Waiver and Visitor Fee submission"
        }
      ]
    }
  };
  const { applications, amenities, types } = additional;
  
  return (
    <Box>
      {/* Original main content */}
      <Box mb={8}>
        <Text as="h2" fontSize="xl" fontWeight="bold" mb={4} color="black">Joining Golden Gun Club</Text>
        
        <Text mb={4} color="black">
          Click for the <Link href="/membership" color="blue.500">the new member application</Link> for the signup form for new members. Membership applications are considered monthly by the Club.
        </Text>

        <Text mb={4} color="black">
          All new Members must attend an orientation session which is usually held the second Saturday of each month. Please check <Link href="/about-us/calendar" color="blue.500">the club calendar</Link> to confirm orientation dates and times.
        </Text>

        <Text mb={4} color="black">
          All Members are held in agreement with the Club's Membership Agreement, and agree to abide by the Range Rules at all times while on the Club facilities.
        </Text>

        <Text mb={4} color="black">
          Memberships are renewed annually each year. Your renewal date is your anniversary date of when you started your membership. We ask that you pay for your membership renewal at least 1 month before it expires. You may pay for your membership renewal up to 90 days before expiration. Please note that all Memberships are subject to the following Rules & Requirements, in addition to Club rules & policies:
        </Text>

        <Box as="ul" ml={6} mb={4} color="black">
          <Box as="li" mb={2}>Members must be at least 18 years of age to hold membership in the Club.</Box>
          <Box as="li" mb={2}>Membership in an approved Second Amendment organization is required for all Members in the club. Approved organizations include: Colorado State Shooting Association (CSSA), Gun Owners of America (GOA), National Association for Gun Rights (NAGR), National Rifle Association (NRA), and Second Amendment Foundation (SAF). Member applicants must submit proof-of-membership with their Club Membership Application.</Box>
          <Box as="li" mb={2}>All newly accepted Members must attend a Member Orientation Class, hosted by the Club at the Club facilities, prior to their membership becoming active. At this session, membership candidates will be instructed about the Club, its rules & regulations, and will be required to demonstrate that they can handle a firearm safely and in accordance with the Club's rules (please bring your own firearm and ammunition to the class).</Box>
        </Box>
      </Box>

      <Center>
        <Text as="h3" color="#000000" fontSize={{ base: '22px' }} fontWeight="600">{applications.title}</Text>
      </Center>
      <Center mt={6}>
        <Link href={applications.new_members} isExternal bg="#FD5521" color="#FFF" p="22px 32px" fontWeight="600" borderRadius="6px">New Member Application</Link>
      </Center>
      <Center mt={6}>
        <Text>Membership Renewals are open for existing members! Please click below to submit your renewal; You can then make your payment by Credit Card over the phone by calling the Club House at 303-366-6970 or you can come in and pay at the Club House in person during business hours. Please see the footer for current hours of operation.</Text>
      </Center>
      <Center mt={6}>
          <Link href={applications.renewal} isExternal bg="#FD5521" color="#FFF" p="22px 32px" fontWeight="600" borderRadius="6px">Member Renewal Application</Link>
      </Center>
      <Center>
        <Text as="h3" color="#000000" fontSize={{ base: '22px' }} fontWeight="600">{types.title}</Text>
      </Center>

      <Center>
        <Text as="p">""</Text>
      </Center>
      <Center>
        <Text as="p">{types.subtitle}</Text>
      </Center>
      {types.ctas.length > 0 && (
        <Flex flexDirection={{ base: 'column', md: 'row' }}>
          {types.ctas.map((cta) => (
            <CallToAction main={cta.main} image={cta.image} title={cta.title} />
          ))}
        </Flex>
      )}

      <Center>
        <Text as="p">""</Text>
      </Center>
      <Center>
        <Text as="h2" color="#000000" fontSize={{ base: '22px' }} fontWeight="600">{amenities.title}</Text>
      </Center>
      <Center>
        <Text as="p">{amenities.subtitle}</Text>
      </Center>
      {amenities.ctas.length > 0 && (
        <Flex flexDirection={{ base: 'column', md: 'row' }}>
          {amenities.ctas.map((cta, index) => index < 3 && (
            <CallToAction main={cta.main} image={cta.image} title={cta.title} />
          ))}
        </Flex>
      )}
      {amenities.ctas.length > 3 && (
        <Flex flexDirection={{ base: 'column', md: 'row' }}>
          {amenities.ctas.map((cta, index) => index > 2 && (
            <CallToAction main={cta.main} image={cta.image} title={cta.title} />
          ))}
        </Flex>
      )}
    </Box>
  )
};
